import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';

import { authApi } from 'api';
import paths from 'routes/paths';

const ProfileDropdown = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await authApi.logout();

      // Clear all local storage data
      localStorage.clear();

      toast.success('Logged out successfully', {
        theme: 'colored',
      });

      navigate('/login', { replace: true });
    } catch (error) {
      toast.error('Failed to logout. Please try again.', {
        theme: 'colored',
      });
    }
  };

  return (
    <Dropdown navbar={true} as="li">
      <Dropdown.Toggle
        bsPrefix="toggle"
        variant="link"
        className="pe-0 ps-2 nav-link"
      >
        <FontAwesomeIcon icon="user-circle" className="fs-7" />
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-caret dropdown-menu-card dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          <Dropdown.Item as={Link} to={paths.myPage}>
            My page
          </Dropdown.Item>
          <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
